/* external Cookiebot */
document.addEventListener('DOMContentLoaded', () => {
  const cookiebotButtons = document.querySelectorAll('.js-cookiebot');

  cookiebotButtons.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof cookiebotFunctions !== 'undefined' && cookiebotFunctions.show) {
        cookiebotFunctions.show();
      }
    });
  });
});


export const cookiebotFunctions = {
    show: () => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

        // Forces the cookie consent dialog to show.
        Cookiebot.show();
    },
    hide: () => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

        // Forces the cookie consent dialog to hide.
        Cookiebot.hide();
    },
    renew: () => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

        // Shows the cookie consent dialog to the website user to renew or change the user’s consent state.
        Cookiebot.renew();
    },
    getScript: (url, async, callback) => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

        /* 
        url: string,
        async: boolean,
        callback: function
       
        Loads a JavaScript-file. URL: Absolute path to the JavaScript-file.
        async (Optional): Determines if the script should load asynchronously.
        callback (Optional): JavaScript function to execute when the script has finished loading.
        */

        Cookiebot.getScript(url, async, callback);
    },
    runScripts: () => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

        /* 
        Evaluates all loaded script tags of type “text/plain” with the attribute “data-cookieconsent” 
        and executes the scripts in accordance with the user’s consent state. For use by websites that 
        load content dynamically, e.g. in single page applications. Scripts are only executed once, 
        so this function is safe to call several times, e.g. every time new content is loaded.
        */

        Cookiebot.runScripts();
    },
    withdraw: () => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

        // Withdraw my consent for this website.

        Cookiebot.withdraw();
    },
    submitCustomConsent: (optinPreferences, optinStatistics, optinMarketing) => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

           /* 
        optinPreferences: boolean,
        optinStatistics: boolean,
        optinMarketing: boolean
       
        Use this outside the context of the cookie banner, such as a button in your site’s header/footer 
        to opt in or out – Or to add a button to your banner that enables partial consent, 
        to for instance “Accept Preferences & Statistics”.
        */

        Cookiebot.submitCustomConsent(optinPreferences, optinStatistics, optinMarketing);
    },
    info: () => {
        if (typeof Cookiebot === 'undefined') {
            return false;
        }

        return {
            'consent' : {
                'necessary' : Cookiebot.consent.necessary,
                'preferences' : Cookiebot.consent.preferences,
                'statistics' : Cookiebot.consent.statistics,
                'marketing' : Cookiebot.consent.marketing,
                'method' : Cookiebot.consent.method
            },
            'consented' : Cookiebot.consented,
            'declined' : Cookiebot.declined,
            'hasResponse' : Cookiebot.hasResponse,
            'doNotTrack' : Cookiebot.doNotTrack,
            'regulations' : {
                'gdprApplies' : Cookiebot.regulations.gdprApplies,
                'ccpaApplies' : Cookiebot.regulations.ccpaApplies,
                'lgpdApplies' : Cookiebot.regulations.lgpdApplies
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/scripts/modules/cookiebot.js